import { Link } from "react-router-dom";
import { Star, Users, FileText, Zap } from "lucide-react";

export default function CourseCard({ course, compact = false }) {
  const discount = course.original_price > course.price
    ? Math.round((1 - course.price / course.original_price) * 100)
    : 0;
  return (
    <Link
      to={`/courses/${course.slug}`}
      className="group block rounded-xl border border-border bg-card overflow-hidden card-hover"
      data-testid={`course-card-${course.slug}`}
    >
      <div className="relative aspect-[16/9] overflow-hidden bg-muted">
        {course.image_url && (
          <img
            src={course.image_url}
            alt={course.title}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        )}
        <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
          {course.bestseller && (
            <span className="tag-pill bg-yellow-400 text-yellow-950">Bestseller</span>
          )}
          {course.new_launch && (
            <span className="tag-pill bg-[color:var(--brand-blue)] text-white">New</span>
          )}
          {!course.bestseller && course.recently_updated && (
            <span className="tag-pill bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300">Updated</span>
          )}
        </div>
        {discount > 0 && (
          <div className="absolute top-3 right-3 rounded-md bg-black/80 px-2 py-1 text-[11px] font-bold text-white">
            −{discount}%
          </div>
        )}
      </div>
      <div className="p-5">
        <div className="text-[11px] uppercase font-bold tracking-[0.18em] text-muted-foreground">
          {course.vendor} · {course.difficulty}
        </div>
        <h3 className="mt-1.5 font-display text-lg leading-snug line-clamp-2">{course.title}</h3>
        {!compact && (
          <p className="mt-1.5 text-sm text-muted-foreground line-clamp-2">{course.subtitle}</p>
        )}
        <div className="mt-3 flex items-center gap-3 text-xs text-muted-foreground">
          <span className="flex items-center gap-1">
            <Star className="h-3.5 w-3.5 fill-yellow-500 stroke-yellow-500" />
            <b className="text-foreground">{(course.rating_avg || 4.7).toFixed(1)}</b> ({course.rating_count || 0})
          </span>
          <span className="flex items-center gap-1">
            <Users className="h-3.5 w-3.5" /> {(course.students_count || 0).toLocaleString()}
          </span>
          <span className="flex items-center gap-1">
            <FileText className="h-3.5 w-3.5" /> {course.question_count}
          </span>
        </div>
        <div className="mt-4 flex items-end gap-2">
          <span className="font-display text-xl">${course.price.toFixed(2)}</span>
          {course.original_price > course.price && (
            <span className="text-sm text-muted-foreground line-through">
              ${course.original_price.toFixed(2)}
            </span>
          )}
          <span className="ml-auto inline-flex items-center gap-1 text-xs font-semibold text-[color:var(--brand-blue)]">
            <Zap className="h-3.5 w-3.5" /> {course.test_count} tests
          </span>
        </div>
      </div>
    </Link>
  );
}
